import React, { lazy, Suspense } from 'react';
import CWOConfigProvider from 'helpers/cwoConfigProvider';
import Loading from 'helpers/loading/loading';

const Component = lazy(() => import('components/agro-operation-weather-widget'));

const AgroOperationWeatherWidget = (props) => (
  <CWOConfigProvider>
    <Suspense fallback={<Loading align="start" />}>
      <Component {...props} />
    </Suspense>
  </CWOConfigProvider>
);

export default AgroOperationWeatherWidget;
